class CookiesController {
    static createCookie(name, value, expiryDate) {
        const date = new Date();
        const now = new Date();
        date.setTime(Date.parse(expiryDate));
        if (date <= now) {
            // session cookie
            document.cookie = `${name}=${value}; path=/`;
        }
        else {
            document.cookie = `${name}=${value}; expires=${date}; path=/`;
        }
    }

    static createCookieWithDuration(name, value, duration) {
        const now = new Date();
        const newDate = new Date(now.getTime() + (duration * 1000));
        document.cookie = `${name}=${value}; expires=${newDate}; path=/`;
    }

    static readCookie(name) {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    static eraseCookie(name) {
        CookiesController.createCookie(name, '', -1);
    }
}

window.CookiesController = CookiesController;
export default CookiesController;

// #endregion
